import {API} from "./API";
import type {RelatedResponse, Specs, WidgetProps} from "../@types/recommendation";
import getRecentProducts from "../utils/getRecentProducts";
import {get} from "svelte/store";
import {cdnCacheKey, platform, recentProducts, storeID, uuid, viewedProduct} from "../store/store";
import {getProductPageID} from "@fast-simon/common"
import {getCartToken} from '@fast-simon/fast-simon-reporting'

const ENDPOINT = "https://api.fastsimon.com";

export const Recommendation = {
    async get({specs}: WidgetProps) {
        return API.get<RelatedResponse>({
            url: `${ENDPOINT}/related_products_suggest`,
            params: {
                request_source: "upsell-cross-sell",
                cart_token: getCartToken(get(platform)),
                specs: JSON.stringify([serializeSpecs(specs)]),
                product_id: getProductPageID(get(platform)) ? getProductPageID(get(platform)) : undefined,
                products: JSON.stringify(getRecentProducts()),
                UUID: get(uuid),
                store_id: get(storeID),
                with_product_attributes: (window as any)?.__fast_options?.with_product_attributes,
                cdn_cache_key: get(cdnCacheKey)
            }
        })
    },
    async getDev({specs}: WidgetProps) {
        return API.get<RelatedResponse>({
            url: `${ENDPOINT}/related_products_suggest`,
            params: {
                request_source: "upsell-cross-sell-dev-mode",
                specs: JSON.stringify([serializeSpecs(specs)]),
                product_id: get(viewedProduct),
                products: get(recentProducts),
                UUID: get(uuid),
                store_id: get(storeID),
                with_product_attributes: (window as any)?.__fast_options?.with_product_attributes
            }
        })
    },
}

const serializeSpecs = (spec: Specs) => ({
    sources: spec.sources.join(","),
    max_suggest: String(spec.maxSuggestions),
    categories: (spec.categoriesIDs ?? []).join(","),
    widget_id: spec.widgetID,
    title: spec.title,
});